import VictronLogoWhite from '@assets/victron-logo-white.svg?react';
import { HIDE_SIDEBAR_KEY } from '@constants/common';
import { DASHBOARD_FOOTER_ITEMS, getDashboardItems } from '@constants/navigation';
import { useAuth } from '@hooks/useAuth';
import { NavbarItem } from '@navbar/components/NavbarItem';
import { cookies } from '@utils/cookies';
import { pathToVP } from '@utils/route';
import { getRoleName } from '@utils/user';
import { useMemo, useState } from 'react';
import { useLocation } from 'react-router-dom';
import './index.less';

const DashboardNavbar = () => {
    const { user, isLoggedIn } = useAuth();
    const [isCollapsed, setIsCollapsed] = useState<boolean>(Boolean(cookies.get(HIDE_SIDEBAR_KEY)));
    const { pathname } = useLocation();

    const handleCollapsed = () => {
        setIsCollapsed(!isCollapsed);
        cookies.set(HIDE_SIDEBAR_KEY, !isCollapsed);
    };

    const dashboardItems = useMemo(
        () => getDashboardItems(isLoggedIn, user).filter((item) => !item.disabled),
        [isLoggedIn, user]
    );

    return (
        <div className="relative" style={{ scrollbarWidth: 'none', minWidth: !isCollapsed ? 250 : 65 }}>
            <div className="overflow-y-auto bg-outer-space-crayola relative h-full flex flex-col">
                {!isCollapsed ? (
                    <p className="text-white h-[121px] flex items-center justify-center p-5">
                        <VictronLogoWhite />
                    </p>
                ) : null}
                <ul className={isCollapsed ? 'pt-[50px]' : ''}>
                    {dashboardItems.map((item) => {
                        const isCurrentPath = pathname === `/app${item.link?.href}`;
                        return (
                            <li key={'navbar-item-' + item.icon + '-' + item.label}>
                                <ul>
                                    <NavbarItem
                                        className={`group/main ${
                                            !item.menuChildren && !isCollapsed
                                                ? `hover:!bg-metallic-blue ${isCurrentPath ? 'bg-metallic-blue' : ''}`
                                                : isCollapsed
                                                ? `hover:!bg-transparent py-3 px-0 ${
                                                      isCurrentPath && !item.menuChildren
                                                          ? '!border-l-4 border-celestial-blue'
                                                          : ''
                                                  }`
                                                : ''
                                        }`}
                                        showChildren
                                        hideExpandIcon
                                        iconProps={{
                                            className: isCollapsed
                                                ? `w-5 h-5 fill-AuroMetalSaurus group-hover/main:fill-white ${
                                                      isCurrentPath && !item.menuChildren ? 'fill-white px-0' : ''
                                                  }`
                                                : 'fill-white',
                                        }}
                                        labelProps={{
                                            className: 'text-white',
                                        }}
                                        hideLabel={isCollapsed}
                                        {...item}
                                    />
                                    {item.menuChildren ? (
                                        <ul className={`${isCollapsed ? 'bg-light-outer-space' : ''}`}>
                                            {item.menuChildren
                                                .filter((item) => !item.disabled)
                                                .map((childItem) => {
                                                    const isCurrentPath = pathname === `/app${childItem.link?.href}`;
                                                    return (
                                                        <NavbarItem
                                                            key={
                                                                'navbar-item-' + childItem.icon + '-' + childItem.label
                                                            }
                                                            {...childItem}
                                                            className={`group/child ${
                                                                isCurrentPath
                                                                    ? !isCollapsed
                                                                        ? 'bg-metallic-blue hover:!bg-metallic-blue'
                                                                        : 'hover:!bg-transparent'
                                                                    : 'hover:!bg-transparent'
                                                            } ${isCollapsed ? '!py-3.5' : '!px-10'}`}
                                                            labelProps={{
                                                                className:
                                                                    'text-chinese-silver group-hover/child:text-white',
                                                            }}
                                                            iconProps={{
                                                                className: `group-hover/child:fill-white fill-chinese-silver ${
                                                                    isCollapsed && isCurrentPath ? 'fill-white' : ''
                                                                }`,
                                                            }}
                                                            hideLabel={isCollapsed}
                                                        />
                                                    );
                                                })}
                                        </ul>
                                    ) : null}
                                </ul>
                            </li>
                        );
                    })}
                </ul>
                <div className="mt-auto mb-5">
                    {!isCollapsed ? (
                        <div className="p-5">
                            <a
                                href={pathToVP('accounts/details/').toString()}
                                className="text-white text-xs font-bold hover:opacity-70 cursor-pointer"
                            >
                                {user?.email}
                            </a>
                            <p className="text-celestial-blue text-xs">{getRoleName(user?.role ?? '')}</p>
                        </div>
                    ) : null}
                    <ul className={isCollapsed ? 'py-[20px]' : ''}>
                        {DASHBOARD_FOOTER_ITEMS.map((footerItem) => (
                            <NavbarItem
                                key={'footer-' + footerItem.label}
                                className={`group ${
                                    !isCollapsed ? 'hover:!bg-metallic-blue' : 'hover:!bg-transparent px-0'
                                }`}
                                {...footerItem}
                                iconProps={{
                                    className: isCollapsed
                                        ? 'w-5 h-5 fill-AuroMetalSaurus group-hover:fill-white'
                                        : 'fill-white',
                                }}
                                labelProps={{
                                    className: 'text-white',
                                }}
                                hideLabel={isCollapsed}
                            />
                        ))}
                    </ul>
                </div>
            </div>
            <div className="MenuCollapser" onClick={handleCollapsed} />
        </div>
    );
};

export { DashboardNavbar };
